import SearchableSelectMenu from "@/app/components/ui/SelectMenus/SearchableSelectMenu";
import { useInventoryProductCopyAPI } from "@/app/hooks/api_hooks/Inventory/useInventoryProductCopyaAPI";
import { useProductParentTitleAPI } from "@/app/hooks/api_hooks/Inventory/useProductParentTitleAPI";
import { Dialog, Transition } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { Fragment, useRef } from "react";
import { useForm } from "react-hook-form";
import clsx from "clsx";
import { PRIMARY_BUTTON, SECONDARY_BUTTON } from "@/constants";

const CopyFromOtherProduct = ({ copyModal, setCopyModal }) => {
  const cancelButtonRef = useRef(null);
  const { execute: fetchParentTitleList } = useProductParentTitleAPI();
  const { execute: productCopyAPI } = useInventoryProductCopyAPI();

  const formHook = useForm<{
    productTheme: string;
    productTitleId: string;
    productTitle: string;
  }>({
    mode: "onChange",
    defaultValues: {},
  });

  const handelCopyForCatelouge = () => {
    productCopyAPI(formHook.getValues("productTitleId"));
    setCopyModal(false);
  };

  return (
    <div>
      <Transition.Root show={copyModal} as={Fragment}>
        <Dialog
          as="div"
          className="fixed inset-0 z-50 overflow-y-auto"
          initialFocus={cancelButtonRef}
          onClose={() => setCopyModal(false)}
        >
          <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Dialog.Overlay className="fixed inset-0 transition-opacity bg-gray-500 bg-opacity-75" />
            </Transition.Child>
            <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">
              &#8203;
            </span>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:w-full sm:max-w-3xl">
                <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                  <div className="flex justify-between items-center my-2">
                    <h2>Copy from other Product </h2>{" "}
                    <span onClick={() => setCopyModal(false)}>
                      <XMarkIcon className="h-4 w-4 cursor-pointer" />
                    </span>
                  </div>
                  <hr />
                  <div className="my-3 flex items-center gap-16">
                    <p>Product</p>
                    <div className="w-2/3 pb-3">
                      <SearchableSelectMenu
                        placeholder="Select Product Title"
                        errorMessages={[{ message: "Product theme is required", type: "required" }]}
                        fieldError={formHook.formState.errors.productTheme}
                        register={formHook.register("productTheme", { required: true })}
                        onSelectItem={(item) => {
                          if (item) {
                            formHook.setValue("productTitle", item.title);
                            formHook.setValue("productTitleId", item.id);
                            formHook.clearErrors("productTitleId");
                          }
                        }}
                        withAPISearch={{
                          apiCallback: fetchParentTitleList,
                          reducerIdKey: "vetic_product_id",
                          reducerTitleKey: "supertails_name",
                        }}
                        defaultSelectedItemForAPISearch={{
                          id: formHook.watch("productTitleId"),
                          title: formHook.watch("productTitle"),
                        }}
                        showDropdownIcon
                        className="text-gray-800"
                        containerClassName="w-full"
                        showTooltips={true}
                        showTypedErrors={true}
                      />
                    </div>
                  </div>
                  <p>{formHook.watch("productTitle")}</p>
                  <div className="bottom-0 flex flex-col sm:flex-row sm:justify-end p-4 gap-3 mt-16">
                    <button
                      type="button"
                      className={clsx(SECONDARY_BUTTON, "w-full sm:w-auto")}
                      onClick={() => setCopyModal(false)}
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className={clsx(PRIMARY_BUTTON, "w-full sm:w-auto")}
                      onClick={() => handelCopyForCatelouge()}
                    >
                      Copy
                    </button>
                  </div>
                </div>
              </div>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition.Root>
    </div>
  );
};

export default CopyFromOtherProduct;
